import {setupMostRead} from "./most-read-widget";
import {setupArticleLike} from "./custom/article-like";
import {setupStateChange} from "./on-change-state";
import {setupShareThis} from "./custom/share";
import {setupSearchPageForm} from "./search";
import {setupAssertiveYield, setupInlineArticleAds} from "./assertive-yield-setup";
//import {InitDFP} from "./dfp";

setupShareThis();
$(() => {
    setupMostRead();
    setupStateChange();
    setupArticleLike();
    setupSearchPageForm();
    setupAssertiveYield();
    setupInlineArticleAds();
    //InitDFP();
})